import React, {useCallback, useRef, useContext, useEffect} from 'react'
import {SearchBox} from '@elastic/react-search-ui'
import {useTranslation} from 'react-i18next'
import {AppContext} from '../../../context/context'

import SearchResetButtonComponent from '../search-reset-button/index'
import {icons} from '../../../theme'

import '@ongov/ontario-design-system-global-styles/dist/styles/css/compiled/ontario-theme.min.css'

import {
  SearchContainer,
  SearchSubmitButton,
  SearchInput,
  SearchLabel,
} from './styles'

const SearchInputComponent = ({inputRef, searchBarOpen}) => {
  const {t} = useTranslation('common')
  const {dispatch, state} = useContext(AppContext)
  const form = useRef(null)

  const setQueryParam = (query, searchType) => {
    const url = new URL(window.location.href)

    // Do not set duplicated history.
    if (url.searchParams.get('query') !== query) {
      url.searchParams.set('query', query)
      url.searchParams.set('search_type', searchType)

      window.history.pushState({}, '', url.toString())
    }
  }

  const handleSubmitClickResults = useCallback(
    async (queryTerm, searchType = 'manual', popState = false) => {
      const trimmedQuery = queryTerm.trim()

      if (trimmedQuery) {
        dispatch({
          payload: {
            query: trimmedQuery,
          },
          type: 'UPDATE_QUERY',
        })
        dispatch({
          payload: {
            filter: 'main',
          },
          type: 'UPDATE_FILTER',
        })

        if (!popState) {
          setQueryParam(trimmedQuery, searchType)
        }
      } else {
        inputRef.value = ''
        inputRef.reportValidity()
      }
    },
    [dispatch, inputRef],
  )

  useEffect(() => {
    if (state.query) {
      form?.current?.state?.setSearchTerm(state.query)
    }
  })

  // Listen to NPM package for autosuggest query submission.
  window.addEventListener('autosuggestionResults', e => {
    handleSubmitClickResults(e.detail.text(), e.detail.searchType())
  })

  // When back/forward button pressed change query state to one in URL query param.
  window.onpopstate = () => {
    const url = new URL(window.location.href)
    const queryParam = url.searchParams.get('query')
    const searchType = url.searchParams.get('searchType')

    handleSubmitClickResults(
      queryParam ? queryParam : '',
      searchType ? searchType : '',
      true,
    )
  }
  return (
    <SearchBox
      ref={form}
      onSubmit={handleSubmitClickResults}
      debounceLength={0}
      shouldClearFilters={false}
      inputView={({getInputProps, getButtonProps}) => (
        <SearchContainer searchOpen={searchBarOpen}>
          <SearchLabel htmlFor="search-input-field">Search</SearchLabel>
          <SearchInput
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck={false}
            ref={inputRef}
            required
            {...getInputProps({
              placeholder: '',
            })}
            id="search-input-field"
          />
          <SearchResetButtonComponent translation={t('search.clearField')} />
          <SearchSubmitButton
            role="button"
            aria-label={t('search.submit')}
            {...getButtonProps({
              value: t('search.search'),
              type: 'submit',
            })}
          >
            {icons.searchSVG}
          </SearchSubmitButton>
        </SearchContainer>
      )}
    />
  )
}

export default SearchInputComponent
